import React from "react";
import { Background } from "../../BuildingBlocks/Background";
import { SpacingRow } from "../../BuildingBlocks/SpacingRow";
import { Text } from "../../BuildingBlocks/Text";
import { CRMColors } from "../../../models/CRMColors";
import { CRMSpacing } from "../../../models/CRMSpacing";
import { CRMFontSizes } from "../../../models/CRMFontSizes";
import * as ListingStatus1 from "../../../../../domain/models/ListingStatus1";
import * as ListingStatusCount1 from "../../../../../domain/models/ListingStatusCount1";
import * as TCRMListings from "../../../state/TCRMListings";
import { listingStatusShortLabel } from "./listingStatusPillStyle";

const STATUS_ORDER: Array<ListingStatus1.T> = [
    "lead",
    "prep_valuation",
    "chase_instruction",
    "instructed_needs_market_prep",
    "instructed_on_the_market",
    "sstc",
    "auction",
    "completed",
    "lost",
];

const Chip = (props: { label: string; count: number; isSelected: boolean; onClick: () => void }): JSX.Element =>
    <Background
        color={props.isSelected ? CRMColors.PRIMARY_2 : CRMColors.NEUTRAL_PAPER}
        borderRadius="16px"
        borderDefinition={`1px solid ${props.isSelected ? CRMColors.PRIMARY_2 : CRMColors.NEUTRAL_8}`}
        padding="0px 14px"
        height="30px"
        display="flex"
        alignItems="center"
        cursor="pointer"
        onClick={props.onClick}
    >
        <SpacingRow spacing={CRMSpacing.TINY}>
            <Text size={CRMFontSizes.SMALL} weight={600} color={props.isSelected ? CRMColors.NEUTRAL_PAPER : CRMColors.NEUTRAL_0}>
                {props.label}
            </Text>
            <Text size={CRMFontSizes.SMALL} weight={700} color={props.isSelected ? CRMColors.PRIMARY_12 : CRMColors.NEUTRAL_4}>
                {props.count.toString()}
            </Text>
        </SpacingRow>
    </Background>;

type TCRMListingStatusChipsProps = {
    selectedStatus: TCRMListings.TSelectedStatus;
    statusCounts: Array<ListingStatusCount1.T>;
    onSelect: (status: TCRMListings.TSelectedStatus) => void;
};

export const CRMListingStatusChips = (props: TCRMListingStatusChipsProps): JSX.Element =>
    <div className="crmListingsPage__chipBar">
        {STATUS_ORDER.map((status) =>
            <Chip
                key={status}
                label={listingStatusShortLabel(status)}
                count={TCRMListings.countForStatus(props.statusCounts, status)}
                isSelected={props.selectedStatus === status}
                onClick={() => props.onSelect(status)}
            />
        )}
        <Chip
            label="All"
            count={TCRMListings.totalCount(props.statusCounts)}
            isSelected={props.selectedStatus === "all"}
            onClick={() => props.onSelect("all")}
        />
    </div>;
